import { render, staticRenderFns } from "./TempoProcessamento.vue?vue&type=template&id=935e0230&scoped=true&"
import script from "./TempoProcessamento.vue?vue&type=script&lang=js&"
export * from "./TempoProcessamento.vue?vue&type=script&lang=js&"
import style0 from "./TempoProcessamento.vue?vue&type=style&index=0&id=935e0230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935e0230",
  null
  
)

export default component.exports